<ion-header mode="ios" class="ion-no-border">
	<ion-toolbar>
		<ion-title size="lg">{{ 'preferences|title' | transloco }}</ion-title>
		<ion-buttons slot="start" class="p-1">
			<button
				(click)="onCancel()"
				type="button"
				ultra-button
				svgIcon="arrow_back"></button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="ion-content-padding">
	<div class="flex flex-col gap-2">
		<div class="flex flex-col mb-4">
			<form [formGroup]="preferencesForm" (ngSubmit)="onSubmit()">
				<app-toggle-new
					formControlName="isTaxIncluded"
					label="preferences|is-tax-included|label"
					class="mb-2" />
				<app-input-field
					[isNumber]="true"
					formControlName="availabilityThreshold"
					label="preferences|availability-threshold|label"
					class="mb-2" />

				<app-single-dropdown
					hideClearButton
					formControlName="language"
					[label]="'preferences|language-selector|label'"
					[selectOptions]="langs" />

				<!-- <input class="w-full p-4" formControlName="logoUri" /> -->
				<ion-fab slot="fixed" class="right-aligned">
					<button
						ultra-primary
						color="primary"
						type="submit"
						[disabled]="isSubmitting()"
						content="shared|common|save"
						svgIcon="check"></button>
				</ion-fab>
			</form>
		</div>
	</div>
</ion-content>
